AuthCodeModalCtrl.$inject = ['$scope', '$uibModalInstance', 'CurrentUser', '$timeout', 'phone']

export default function AuthCodeModalCtrl($scope, $uibModalInstance
, CurrentUser, $timeout, phone) {

  $scope.error = null;
  $scope.busy = false;
  $scope.authCode = '';
  $scope.phone = phone;

  $timeout(function () {
    document
      .querySelector('.modal-container')
      .querySelector('input[name="authCode"]').focus()
  });

  $scope.verifyAuthCode = function () {
    if ($scope.busy) return;
    $scope.busy = true;
    CurrentUser.api.verifyAuthCode(null, {
      token: $scope.authCode
    }).then(function () {
      CurrentUser.api.get().then(function (data) {
        $uibModalInstance.close(data);
      });
    }, function (response) {
      $scope.busy = false;
      document
        .querySelector('.modal-container')
        .querySelector('input[name="authCode"]').focus()
      $scope.error = response.data;
    });
  };
};



// WEBPACK FOOTER //
// ./project/modals/auth-code/auth-code.controller.js